module.exports = __webpack_public_path__ + "static/media/pexels-hermaion-205414.933eccd9.jpg";